<template>
  <v-card>
    <v-card-title>Reports</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="6">
            <v-select
              :items="schoolYears"
              item-text="description"
              item-value="id"
              label="Report for School Year"
              v-model="schoolYearSelected"
              return-object
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="primary"
              class="mr-2"
              :disabled="schoolYearSelected.id === 0"
              @click="generateSummaryReport"
            >
              <v-icon left>mdi-file-download-outline</v-icon>Summary
            </v-btn>
            <v-btn
              color="primary"
              class="mr-2"
              :disabled="schoolYearSelected.id === 0"
              @click="generatePaidFeesReport(true)"
            >
              <v-icon left>mdi-file-download-outline</v-icon>Paid Fees
            </v-btn>
            <v-btn
              color="primary"
              class="mr-2"
              :disabled="schoolYearSelected.id === 0"
              @click="generatePaidFeesReport(false)"
            >
              <v-icon left>mdi-file-download-outline</v-icon>Unpaid Fees
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-radio-group
              v-model="subjectId"
              label="Subject"
              row
              :mandatory="true"
            >
              <div v-for="s in subjects" :key="s.id">
                <v-radio :label="s.description" :value="s.id"></v-radio>
              </div>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-radio-group v-model="gradeLevel" label="Grade Level" row>
              <v-radio label="1" value="1"></v-radio>
              <v-radio label="2" value="2"></v-radio>
              <v-radio label="3" value="3"></v-radio>
              <v-radio label="4" value="4"></v-radio>
              <v-radio label="5" value="5"></v-radio>
              <v-radio label="6" value="6"></v-radio>
              <v-radio label="7" value="7"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-btn
              class="mr-2"
              color="primary"
              :disabled="schoolYearSelected.id === 0"
              @click="generateRegistrationReport"
            >
              <v-icon left>mdi-file-download-outline</v-icon>Registration Report
            </v-btn>
            <v-btn
              color="primary"
              :disabled="schoolYearSelected.id === 0"
              @click="generateMarksReport"
            >
              <v-icon left>mdi-file-download-outline</v-icon>Marks Report
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="title">Admin Credit Report</v-col>
        </v-row>
        <v-row>
          <v-col cols="5" sm="3">
            <v-menu
              ref="startDateMenu"
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="startDate"
                min="2020-01-01"
                @change="saveStartDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="5" sm="3">
            <v-menu
              ref="endDateMenu"
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="endDate"
                min="2020-01-01"
                @change="saveEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" sm="6">
            <v-btn
              color="primary"
              class="mr-2"
              :disabled="schoolYearSelected.id === 0"
              @click="generateAdminCreditReport"
            >
              <v-icon left>mdi-file-download-outline</v-icon>
              Admin Transactions Report
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <ReturnHomeBtn />
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { dataService, errorMessageMixin, lateFeeMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";

export default {
  name: "Reports",
  mixins: [errorMessageMixin, lateFeeMixin],
  components: { ReturnHomeBtn },

  async created() {
    await this.loadSchoolYear();
    await this.loadSchoolYears();

    if (this.schoolYear) {
      this.schoolYearSelected = this.schoolYear;
    } else {
      this.schoolYearSelected = this.schoolYears[0];
    }

    await this.loadSubjects();
    console.log("loaded subjects", this.subjects[0].id.toString());

    if (!this.examFees) {
      this.loadExamFees();
    }
  },
  mounted() {
    //this.subjectId = this.subjects[0].id.toString();
  },
  computed: {
    ...mapState(["schoolYears", "schoolYear", "subjects", "examFees"])
  },
  data() {
    return {
      schoolYearSelected: {
        id: 0
      },
      gradeLevel: "1",
      subjectId: "1",
      startDateMenu: false,
      startDate: new Date().toISOString().substr(0, 10),
      endDateMenu: false,
      endDate: new Date().toISOString().substr(0, 10)
    };
  },
  watch: {
    subjectId: function() {
      console.log("in watch", this.subjectId);
    },
    schoolYearSelected: function() {
      console.log("schoolYearSelected watch");

      this.startDate = this.schoolYearSelected.registrationStartDate.substr(
        0,
        10
      );
      this.endDate = this.schoolYearSelected.registrationEndDate.substr(0, 10);
    }
  },

  methods: {
    ...mapActions([
      "getSchoolYearsAction",
      "getSchoolYearAction",
      "getSubjectsAction",
      "getExamFeesAction"
    ]),
    async loadExamFees() {
      await this.getExamFeesAction();
    },
    async loadSchoolYears() {
      try {
        await this.getSchoolYearsAction();
        if (this.$store.state.schoolYears == null) {
          this.$router.push({
            name: "Home"
          });
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    async loadSchoolYear() {
      await this.getSchoolYearAction();
    },
    async loadSubjects() {
      await this.getSubjectsAction();
    },
    async generateRegistrationReport() {
      try {
        this.$store.state.fullScreenLoading = true;

        let detailModel = await dataService.getExamRegistrationDetail(
          this.schoolYearSelected.id,
          this.subjectId,
          this.gradeLevel,
          this.$store.state.token
        );
        console.log("detailModel", detailModel);

        if (detailModel && detailModel.data && detailModel.data.length > 0) {
          let csv =
            this.schoolYearSelected.description +
            " for " +
            detailModel.subjectDescription +
            " as of " +
            this.currentDateString() +
            "\n" +
            "Subject,GradeLevel,Child Id,Child FirstName,Child LastName,Teacher FirstName,Teacher LastName," +
            "Teacher Phone#,Parent FirstName,Parent LastName,Parent Email, Parent Phone#\n";

          for (let i = 0; i < detailModel.data.length; i++) {
            csv =
              csv +
              detailModel.data[i].subject +
              "," +
              detailModel.data[i].gradeLevel +
              "," +
              detailModel.data[i].childId +
              "," +
              this.cleanString(detailModel.data[i].childFirstName) +
              "," +
              this.cleanString(detailModel.data[i].childLastName) +
              "," +
              this.cleanString(detailModel.data[i].teacherFirstName) +
              "," +
              this.cleanString(detailModel.data[i].teacherLastName) +
              "," +
              this.cleanString(detailModel.data[i].teacherPhoneNumber) +
              "," +
              this.cleanString(detailModel.data[i].parentFirstName) +
              "," +
              this.cleanString(detailModel.data[i].parentLastName) +
              "," +
              this.cleanString(detailModel.data[i].parentEmailAddress) + ";" +
              "," +
              this.cleanString(detailModel.data[i].parentPhoneNumber) +
              "\n";
          }

          // let csv = "greet, grade, name\nhello,1,noel\nhi,2,reena\n";
          let anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download =
            "ExamRegistrationDetail-" +
            detailModel.schoolYearDescription +
            "-" +
            detailModel.subjectDescription +
            "-grade" +
            detailModel.gradeLevel +
            ".csv";
          anchor.click();
        } else {
          this.$store.state.error = "No data to report.";
          this.$store.state.snackbarColor = "warning";
          this.$store.state.snackbar = true;
        }
      } catch (err) {
        console.log("in generate report err", err);
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      } finally {
        this.$store.state.fullScreenLoading = false;
      }
    },
    async generateSummaryReport() {
      try {
        this.$store.state.fullScreenLoading = true;

        let summaryModel = await dataService.getExamRegistrationSummary(
          this.schoolYearSelected.id,
          this.$store.state.token
        );
        console.log("summaryModel", summaryModel);

        if (summaryModel && summaryModel.data && summaryModel.data.length > 0) {
          console.log("there is something to reprot!");

          let csv =
            this.schoolYearSelected.description +
            " as of " +
            this.currentDateString() +
            "\n" +
            "Subject,GradeLevel,Total Students,Total Unpaid,Total Paid,Total Amount\n";

          for (let i = 0; i < summaryModel.data.length; i++) {
            csv =
              csv +
              summaryModel.data[i].subject +
              "," +
              summaryModel.data[i].gradeLevel +
              "," +
              summaryModel.data[i].totalStudents +
              "," +
              summaryModel.data[i].totalUnpaidAmount +
              "," +
              summaryModel.data[i].totalPaidAmount +
              "," +
              summaryModel.data[i].totalAmount +
              "\n";
          }

          // let csv = "greet, grade, name\nhello,1,noel\nhi,2,reena\n";
          let anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download =
            "ExamRegistrationSummary-" +
            this.schoolYearSelected.description +
            ".csv";
          anchor.click();
        } else {
          this.$store.state.error = "No data to report.";
          this.$store.state.snackbarColor = "warning";
          this.$store.state.snackbar = true;
        }
      } catch (err) {
        console.log("in generate report err", err);
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      } finally {
        this.$store.state.fullScreenLoading = false;
      }
    },
    async generateMarksReport() {
      try {
        this.$store.state.fullScreenLoading = true;

        let detailModel = await dataService.getMarksDetail(
          this.schoolYearSelected.id,
          this.subjectId,
          this.gradeLevel,
          this.$store.state.token
        );
        console.log("detailModel", detailModel);

        if (detailModel && detailModel.data && detailModel.data.length > 0) {
          let csv =
            "Exam Detail - School Year " +
            this.schoolYearSelected.description +
            " for " +
            detailModel.subjectDescription +
            " as of " +
            this.currentDateString() +
            "\n" +
            "Subject, GradeLevel, Child Id, Child FirstName, Child LastName, Result, Total Mark, Calculated Theory, Calculated Practical, Total Practical, Total Theory," +
            "Theory Grace Mark, Oral Grace Mark, Grace Mark, Theory Mark, Practical Mark1, Practical Mark2, Practical Mark3, Practical Mark4, Practical Mark5," +
            "Oral Mark1,Oral Mark2,Oral Mark3," +
            "Parent FirstName,Parent LastName,Parent Email,Parent Phone#,Address," +
            "Teacher FirstName,Teacher LastName,Teacher Phone#\n";

          for (let i = 0; i < detailModel.data.length; i++) {
            csv =
              csv +
              detailModel.data[i].subject +
              "," +
              detailModel.data[i].gradeLevel +
              "," +
              detailModel.data[i].childId +
              "," +
              this.cleanString(detailModel.data[i].childFirstName) +
              "," +
              this.cleanString(detailModel.data[i].childLastName) +
              "," +
              detailModel.data[i].examGradeType +
              "," +
              detailModel.data[i].totalMark +
              "," +
              detailModel.data[i].calculatedTheoreticalMark +
              "," +
              detailModel.data[i].calculatedPracticalMark +
              "," +
              detailModel.data[i].totalPracticalOralMark +
              "," +
              detailModel.data[i].totalTheoreticalMark +
              "," +
              detailModel.data[i].theoreticalGraceMark +
              "," +
              detailModel.data[i].oralGraceMark +
              "," +
              detailModel.data[i].graceMark +
              "," +
              detailModel.data[i].theoryMark +
              "," +
              detailModel.data[i].practicalMark1 +
              "," +
              detailModel.data[i].practicalMark2 +
              "," +
              detailModel.data[i].practicalMark3 +
              "," +
              detailModel.data[i].practicalMark4 +
              "," +
              detailModel.data[i].practicalMark5 +
              "," +
              detailModel.data[i].oralMark1 +
              "," +
              detailModel.data[i].oralMark2 +
              "," +
              detailModel.data[i].oralMark3 +
              "," +
              this.cleanString(detailModel.data[i].parentFirstName) +
              "," +
              this.cleanString(detailModel.data[i].parentLastName) +
              "," +
              this.cleanString(detailModel.data[i].parentEmailAddress) + ";" +
              "," +
              this.cleanString(detailModel.data[i].parentPhoneNumber) +
              "," +
              this.cleanString(detailModel.data[i].parentAddress) +
              "," +
              this.cleanString(detailModel.data[i].teacherFirstName) +
              "," +
              this.cleanString(detailModel.data[i].teacherLastName) +
              "," +
              this.cleanString(detailModel.data[i].teacherPhoneNumber) +
              "\n";
          }

          // let csv = "greet, grade, name\nhello,1,noel\nhi,2,reena\n";
          let anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download =
            "MarksDetail-" +
            detailModel.schoolYearDescription +
            "-" +
            detailModel.subjectDescription +
            "-grade" +
            detailModel.gradeLevel +
            ".csv";
          anchor.click();
        } else {
          this.$store.state.error = "No data to report.";
          this.$store.state.snackbarColor = "warning";
          this.$store.state.snackbar = true;
        }
      } catch (err) {
        console.log("in generate report err", err);
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      } finally {
        this.$store.state.fullScreenLoading = false;
      }
    },
    async generatePaidFeesReport(isPaid) {
      try {
        this.$store.state.fullScreenLoading = true;

        let detailModel = await dataService.getFeesDetail(
          this.schoolYearSelected.id,
          isPaid,
          this.$store.state.token
        );
        console.log("detailModel", detailModel);

        if (detailModel && detailModel.data && detailModel.data.length > 0) {
          let csv =
            (isPaid ? "Paid" : "Unpaid") +
            " Fees Detail - School Year " +
            this.schoolYearSelected.description +
            " as of " +
            this.currentDateString() +
            "\n" +
            "Subject,GradeLevel,Fee Amount,Is Paid,Payment Date,Payment Reference," +
            "Child Id,Child FirstName,Child LastName," +
            "Parent FirstName,Parent LastName,Parent Email,Parent Phone#,Address," +
            "Teacher FirstName,Teacher LastName,Teacher Phone#\n";

          for (let i = 0; i < detailModel.data.length; i++) {
            var fee = this.getExamFee(
              detailModel.data[i].gradeLevel,
              this.schoolYearSelected.isTheoreticalExamsOnly
            );

            csv =
              csv +
              detailModel.data[i].subject +
              "," +
              detailModel.data[i].gradeLevel +
              "," +
              (detailModel.data[i].isPaid
                ? detailModel.data[i].feeAmount
                : fee) +
              "," +
              (detailModel.data[i].isPaid ? "Paid" : "Unpaid") +
              "," +
              detailModel.data[i].paymentDate +
              "," +
              this.cleanString(detailModel.data[i].paymentReference) +
              "," +
              detailModel.data[i].childId +
              "," +
              this.cleanString(detailModel.data[i].childFirstName) +
              "," +
              this.cleanString(detailModel.data[i].childLastName) +
              "," +
              this.cleanString(detailModel.data[i].parentFirstName) +
              "," +
              this.cleanString(detailModel.data[i].parentLastName) +
              "," +
              this.cleanString(detailModel.data[i].parentEmail) + ";" + 
              "," +
              this.cleanString(detailModel.data[i].parentPhoneNumber) +
              "," +
              this.cleanString(detailModel.data[i].parentAddress) +
              "," +
              this.cleanString(detailModel.data[i].teacherFirstName) +
              "," +
              this.cleanString(detailModel.data[i].teacherLastName) +
              "," +
              this.cleanString(detailModel.data[i].teacherPhoneNumber) +
              "\n";
          }

          // let csv = "greet, grade, name\nhello,1,noel\nhi,2,reena\n";
          let anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download =
            (isPaid ? "Paid" : "Unpaid") +
            "FeesDetail-" +
            detailModel.schoolYearDescription +
            ".csv";
          anchor.click();
        } else {
          this.$store.state.error = "No data to report.";
          this.$store.state.snackbarColor = "warning";
          this.$store.state.snackbar = true;
        }
      } catch (err) {
        console.log("in generate report err", err);
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      } finally {
        this.$store.state.fullScreenLoading = false;
      }
    },
    cleanString(text) {
      return '"' + String(text).replace(/"/g, "'") + '"';
    },
    currentDateString() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      return yyyy + "-" + mm + "-" + dd;
    },
    saveStartDate(date) {
      this.$refs.startDateMenu.save(date);
    },
    saveEndDate(date) {
      this.$refs.endDateMenu.save(date);
    },
    async generateAdminCreditReport() {
      console.log("start", this.startDate);
      console.log("end", this.endDate);
      try {
        this.$store.state.fullScreenLoading = true;

        let detailModel = await dataService.getAdminTransactionsDetail(
          this.startDate,
          this.endDate,
          this.$store.state.token
        );
        console.log("detailModel", detailModel);

        if (detailModel && detailModel.data && detailModel.data.length > 0) {
          let csv =
            "Admin Transactions from " +
            this.startDate +
            " to " +
            this.endDate +
            " as of " +
            this.currentDateString() +
            "\n" +
            "Admin Id,Admin FirstName, Created Date,Record Type,Amount,Account Id," +
            "Parent FirstName,Parent LastName,Reference Id,Notes,Exam Registrations\n";

          for (let i = 0; i < detailModel.data.length; i++) {
            csv =
              csv +
              detailModel.data[i].adminId +
              "," +
              this.cleanString(detailModel.data[i].adminFirstName) +
              "," +
              detailModel.data[i].createdDate +
              "," +
              detailModel.data[i].recordType +
              "," +
              detailModel.data[i].amount +
              "," +
              detailModel.data[i].accountId +
              "," +
              this.cleanString(detailModel.data[i].parentFirstName) +
              "," +
              this.cleanString(detailModel.data[i].parentLastName) +
              "," +
              detailModel.data[i].referenceId +
              "," +
              this.cleanString(detailModel.data[i].notes) +
              "," +
              this.cleanString(detailModel.data[i].examRegistrations) +
              "\n";
          }

          // let csv = "greet, grade, name\nhello,1,noel\nhi,2,reena\n";
          let anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download =
            "AdminTransactionsDetail-" +
            this.startDate +
            "to" +
            this.endDate +
            ".csv";
          anchor.click();
        } else {
          this.$store.state.error = "No data to report.";
          this.$store.state.snackbarColor = "warning";
          this.$store.state.snackbar = true;
        }
      } catch (err) {
        console.log("in generate report err", err);
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      } finally {
        this.$store.state.fullScreenLoading = false;
      }
    }
  }
};
</script>
